<template>
  <div class="tw-container tw-mx-auto tw-pt-8">
    <div
      v-if="$isInRole(['ADMIN', 'CONSULTANT'])"
      class="tw-mb-8"
    >
      <i-button
        @click="isAddPermitDialogOpen = true"
      >
        <icon-plus />
        {{ $t('foreigners.permits.add') }}
      </i-button>
      <AddPermitDialog
        :is-open="isAddPermitDialogOpen"
        @close="isAddPermitDialogOpen = false"
      />
    </div>

    <div
      v-for="[statusName, permits] in Object.entries(permitsByStatus)"
      :key="statusName"
      class="tw-mb-10"
    >
      <h2 class="tw-mb-4 tw-tracking-wide">
        {{ statusName }}
      </h2>

      <div class="tw-grid tw-grid-cols-2 tw-gap-5">
        <PermitBox
          v-for="permit in permits"
          :key="permit.id"
          :permit="permit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _groupBy from 'lodash/groupBy';
import AddPermitDialog from '@/components/Dialogs/AddPermitDialog.vue';
import PermitBox from '@/components/Permits/PermitBox.vue';

export default {
  name: 'ForeignersPermitsV2',
  components: {
    AddPermitDialog,
    PermitBox,
  },

  data() {
    return {
      isAddPermitDialogOpen: false,
    };
  },

  computed: {
    permitsByStatus() {
      return _groupBy(this.$store.state.v2.admin.foreigners.foreigner.permits, (permit) => (this.$store.getters['v2/shared/enums/get']('permit_types', permit.permit_status) || { name: '' }).name);
    },
  },
};
</script>
